import { Box, Card, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { tint } from "../utils/colors";
import { ANIMATE } from "../utils/motion";

/** One headline number with an icon tile. Clickable when `onClick` is given. */
export default function StatCard({ icon, label, value, hint, color = "#4F46E5", onClick, index = 0 }) {
  return (
    <motion.div
      initial={ANIMATE ? { opacity: 0, y: 14 } : false}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
    >
      <Card
        onClick={onClick}
        sx={{
          p: 2.5,
          height: "100%",
          cursor: onClick ? "pointer" : "default",
          transition: "transform .18s ease, box-shadow .18s ease",
          "&:hover": onClick
            ? { transform: "translateY(-3px)", boxShadow: "0 12px 32px rgba(15,23,42,0.12)" }
            : undefined,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
            {label}
          </Typography>
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: 2.5,
              display: "grid",
              placeItems: "center",
              color,
              backgroundColor: tint(color, 0.12),
            }}
          >
            {icon}
          </Box>
        </Box>
        <Typography sx={{ fontSize: 34, fontWeight: 800, letterSpacing: "-0.03em", lineHeight: 1.1 }}>
          {value}
        </Typography>
        {hint && (
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.75 }}>
            {hint}
          </Typography>
        )}
      </Card>
    </motion.div>
  );
}
